import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { ConfirmationModalComponent } from "../../components/shared/confirmation-modal/confirmation-modal.component";
import { ResetPasswordService, TestPostRequest } from '../../services/reset-password/reset-password.service';
import { SuccessAlertComponent } from "../shared/success-alert/success-alert.component";
import { ErrorAlertComponent } from "../shared/error-alert/error-alert.component";
import { LoadingService } from '../../services/general/loading.service';
import { Router } from '@angular/router';
import { LogTackingService } from '../../services/logs/log-tacking.service';
import { LoginService } from '../../services/login/login.service';
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule,ConfirmationModalComponent,ErrorAlertComponent,SuccessAlertComponent],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  // mínimo 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial
  passwordPolicyRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  usuario = '';
  password = '';
  confirm_password = '';
  respuesta = '';
  ip = ''
  isModalVisible: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  showAlertError: boolean = false
  showAlerSuccess: boolean = false
  message1ForSuccesAlert = 'Cambio de contraseña Exitoso'
  message2ForSuccesAlert = ''
  log_info: LogsTrackingRequest = {
    email: '',
    action: 'Reiniciar Contraseña DA',
    details: '',
    ip_address: ''
  }

  constructor(
    private testPostService: ResetPasswordService,
    private _loadingService: LoadingService,
    private router : Router,
    private _logsService: LogTackingService,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    this.getIp()  
    const email = sessionStorage.getItem('email');
    if (email) {
      setTimeout(() => {
        this.usuario = email.split('@')[0];
      });
    } else {
      console.warn('No se encontró el correo electrónico en sessionStorage');
      this.router.navigate(['/home']);
    }
  }

  createTrackingLog() {
      this._logsService.generateTrackingLog(this.log_info).subscribe({
        next: (response: LogsTrackingResponse) => { console.log(response)},
        error: (error) => {
          console.log(error);
        }
      });
    }

  handleInvalidToken(form: NgForm): void {
    this.isModalVisible = false;
    this._loadingService.setLoading(false);
    //Limpia sessionStorage
    sessionStorage.clear();
    form.resetForm();
    this.router.navigate(['/home']);
  }

  showErrorComponent(form: NgForm) {
    this.isModalVisible = false;
    this._loadingService.setLoading(false);
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
    }, 8000);
  }

  cerrarSesion() {
    this._loadingService.setLoading(true);
    this.testPostService.logout().subscribe({
      next: (res) => {
        sessionStorage.clear();
        this._loadingService.setLoading(false);
        this.router.navigate(['/home']);
      },
      error: (error) => {
        console.error('Error al cerrar sesión:', error);
        this._loadingService.setLoading(false);
      }
    });
  }
  
  showSuccessComponent(form: NgForm) {
    this.showAlerSuccess = true
    this._loadingService.setLoading(false)
    this.message2ForSuccesAlert = `Recuerda que la contraseña te sirve para ingresar al equipo, red y VPN`
    form.resetForm();
    setTimeout(() => {
      this.cerrarSesion()
      sessionStorage.clear();
      this.router.navigate(['/home']);
    }, 7000);
  }

  onSubmit(form: NgForm) {
    // Validación: campos vacíos
    if (!this.password || !this.confirm_password) {
      this.respuesta = 'Por favor completa todos los campos de contraseña.';
      return;
    }

    // Validación: que coincidan
    if (this.password !== this.confirm_password) {
      this.respuesta = 'Las contraseñas no coinciden.';
      return;
    }

    // Validación: la contraseña debe cumplir con la política definida
    if (!this.passwordPolicyRegex.test(this.password)) {
      this.respuesta = 'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.';
      return;
    }
    this.isModalVisible = true;
  }

  onConfirm(form: NgForm): void {
    this._loadingService.setLoading(true)
    const body: TestPostRequest = {
      Usuario: this.usuario,
      Password: this.password
    };
    this.log_info.email = String(sessionStorage.getItem('email'))
    this.log_info.ip_address = this.ip
    this.testPostService.sendData(body).subscribe({
      next: (res) => {
        this.log_info.details = "Success: Cambio de contraseña exitoso"
        this.createTrackingLog()
        this.showSuccessComponent(form)
      },
      error: (err) => {
        this.errorMessage = err.error.message
        const msg = err?.error?.message;
        this.log_info.details = `Error: ${msg}`
        if (msg === 'No autorizado: el usuario autenticado no coincide' || msg === 'Token expirado' || msg === 'Token no encontrado en cookies') {
          this.createTrackingLog()
          this.handleInvalidToken(form);
        } else {
          this.createTrackingLog()
          this.showErrorComponent(form);
          console.error(err);
        }
        
      }
    });
  }
  
  onCancel(): void {
    this.isModalVisible = false;
  }

  getIp(){
    this.loginService.getIPAddress().subscribe((data: any) => {
      this.ip = data.IPv4
      localStorage.setItem('ip', this.ip)
    });
  }
}
